import React, { ReactElement, ForwardedRef } from 'react';
import FormatService from '../../services/format-service';
import useStylesFlexContainer from './flex-container.styles';

const FlexContainer: ReactMemoComponent = React.memo(React.forwardRef((
  props: ReactComponentProps,
  ref: ForwardedRef<HTMLDivElement>,
): ReactElement => {
  const {
    isDefault,
    isStart,
    isEnd,
    isFlexStart,
    isColumn,
    isSpread,
    isInline,
    isCentered,
    isFloatLeft,
    isFloatRight,
    isFullWidth,
    isFullHeight,
    isTextLeft,
    isTextCenter,
    withNoAlign,
    withSpaceAround,
    className,
    style,
    children,
    ...custom
  } = props;

  const { classes } = useStylesFlexContainer();

  const startClassName: string | undefined = isStart ? classes.flexContainerStart : undefined;
  const endClassName: string | undefined = isEnd ? classes.flexContainerEnd : undefined;
  const flexStartClassName: string | undefined = isFlexStart ? classes.flexContainerFlexStart : undefined;
  const columnClassName: string | undefined = isColumn ? classes.flexContainerColumn : undefined;
  const spreadClassName: string | undefined = isSpread ? classes.flexContainerSpread : undefined;
  const inlineClassName: string | undefined = isInline ? classes.flexContainerInline : undefined;
  const centeredClassName: string | undefined = isCentered ? classes.flexContainerCentered : undefined;
  const floatLeftClassName: string | undefined = isFloatLeft ? classes.flexContainerFloatLeft : undefined;
  const floatRightClassName: string | undefined = isFloatRight ? classes.flexContainerFloatRight : undefined;
  const fullWidthClassName: string | undefined = isFullWidth ? classes.flexContainerFullWidth : undefined;
  const fullHeightClassName: string | undefined = isFullHeight ? classes.flexContainerFullHeight : undefined;
  const textLeftClassName: string | undefined = isTextLeft ? classes.flexContainerTextLeft : undefined;
  const textCenterClassName: string | undefined = isTextCenter ? classes.flexContainerTextCenter : undefined;
  const noAlignClassName: string | undefined = withNoAlign ? classes.flexContainerNoAlign : undefined;
  const spaceAroundClassName: string | undefined = withSpaceAround ? classes.flexContainerSpaceAround : undefined;
  const defaultClassName: string | undefined = isDefault ? classes.flexContainerDefault : undefined;

  return (
    <div
      ref={ref}
      className={FormatService.formatClassNames(
        classes.flexContainer, startClassName, endClassName, flexStartClassName, columnClassName, spreadClassName,
        inlineClassName, centeredClassName, floatLeftClassName, floatRightClassName, fullWidthClassName,
        fullHeightClassName, textLeftClassName, textCenterClassName, noAlignClassName, spaceAroundClassName,
        defaultClassName, className,
      )}
      style={style}
      {...custom}
    >
      {children}
    </div>
  );
}));

export default FlexContainer;
